import { render } from "./affTicket.vue?vue&type=template&id=418a012a"
import script from "./affTicket.vue?vue&type=script&lang=ts"
export * from "./affTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script